import React, { useCallback, useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { FILE_HOSTING } from '../../constants/general';
import TitleBar from '../Shared/TitleBar';
import NotAuthorizedMessage from './NotAuthorizedMessage';
import { Grid } from '@material-ui/core';
import { useIsAuthenticated } from '@azure/msal-react';
import Resource from './Resource';
import useLoginRedirect from '../../hooks/useLoginRedirect';
import { useLocation } from 'react-router-dom';

const Resources = inject('AuthStore')(
  observer(({ AuthStore: authStore }) => {
    const [loading, setLoading] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const isAuthenticated = useIsAuthenticated();
    const redirectToLogin = useLoginRedirect();
    const [closeWindowAfterDownload, setCloseWindowAfterDownload] = useState(false);
    const location = useLocation();

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      if (params && params.has(FILE_HOSTING.CLOSE_WINDOW)) {
        setCloseWindowAfterDownload(params.get(FILE_HOSTING.CLOSE_WINDOW) === 'true');
      }
    }, []);

    const checkReady = useCallback(() => {
      if (!authStore) return { isLoading: true };
      return {
        isLoading: authStore.loading,
        user: authStore.user,
      };
    }, [authStore]);

    useEffect(() => {
      const { isLoading, user } = checkReady();
      setLoading(isLoading);
      setLoggedIn(!!user);

      if (!isLoading && !user) {
        redirectToLogin();
      }
    }, [checkReady, redirectToLogin]);

    const handleAfterDownload = useCallback(() => {
      if (closeWindowAfterDownload) {
        window.close();
      }
    }, [closeWindowAfterDownload]);

    return (
      <>
        <Grid container style={{ width: '99vw', marginTop: '35px' }}>
          {!closeWindowAfterDownload && (
            <TitleBar title={FILE_HOSTING.RESOURCE} currentPage={FILE_HOSTING.RESOURCE} paths={[{ path: '/', name: 'Home', onClickFunc: null }]} />
          )}
          {!loading && loggedIn && !isAuthenticated ? (
            <NotAuthorizedMessage message={FILE_HOSTING.NOT_AUTHORIZED} />
          ) : (
            <Resource authStore={authStore} onDownloadComplete={closeWindowAfterDownload ? handleAfterDownload : undefined} />
          )}
        </Grid>
      </>
    );
  })
);

export default Resources;
